var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_209",
    "data-name": "Gruppe 209",
    transform: "translate(-375 -183.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_318",
    "data-name": "Rechteck 318",
    width: 34,
    height: 6,
    rx: 1,
    transform: "translate(375 183.872)",
    fill: "#f953c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_319",
    "data-name": "Rechteck 319",
    width: 13,
    height: 6,
    rx: 1,
    transform: "translate(387 194.872)",
    fill: "#f953c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_320",
    "data-name": "Rechteck 320",
    width: 22,
    height: 6,
    rx: 1,
    transform: "translate(381 194.872) rotate(90)",
    fill: "#f953c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_321",
    "data-name": "Rechteck 321",
    width: 11,
    height: 6,
    rx: 1,
    transform: "translate(400 186.872) rotate(90)",
    fill: "#f953c6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.427a04e5028081053020879180b5134b.svg";
export { ForwardRef as ReactComponent };